import './index.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-toastify/dist/ReactToastify.css';

import { AddCompany, AddCustomer, AddDelivery, AddParcelDelivery, AddPickupPoint, AddUser, AddVehicle, CompanyRegister, Dashboard, DeveloperHub, EditCustomer, EditDelivery, EditFleet, EditParcelDelivery, EditPickupPoint, EditUser, EditVehicle, ForgotPassword, HelpSupport, Login, NotFound, PasswordChange, PickupPoints, Register, ResetPassword, ViewCompany, ViewCustomers, ViewDeliveries, ViewFleets, ViewParcels, ViewProducts, ViewServices, ViewSettings, ViewUsers, ViewVehicles } from './modules';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { persistor, store } from './store';

import { AddFleet } from './modules/vehicle/AddFleet';
import AppContainer from './modules/AppContainer';
import { ChakraProvider } from '@chakra-ui/react';
import { PersistGate } from 'redux-persist/integration/react';
import { ProtectedRoute } from './utils';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

const appRouting = (
  <Routes>
    <Route path='/login' element={<Login />} />
    <Route path='/register' element={<Register />} />
    <Route path='/forgot-password' element={<ForgotPassword />} />
    <Route path='/reset-password' element={<ResetPassword />} />
    <Route path='*' element={<NotFound />} />
    <Route
      path='/'
      element={
        <ProtectedRoute
          component={<Dashboard />}
        />
      }
    />
    <Route
      path='/dashboard'
      element={
        <ProtectedRoute
          component={<Dashboard />}
        />
      }
    />
    <Route
      path='/deliveries'
    >
      <Route
        path=''
        element={
          <ProtectedRoute
            component={<ViewDeliveries />}
          />
        }
      />
      <Route
        path='add'
        element={
          <ProtectedRoute
            component={<AddDelivery />}
          />
        }
      />
      <Route
        path=':delivery_id/edit'
        element={
          <ProtectedRoute
            component={<EditDelivery />}
          />
        }
      />
    </Route>
    <Route
      path='/company'
    >
      <Route
        path=''
        element={
          <ProtectedRoute
            component={<ViewCompany />}
          />
        }
      />
      <Route
        path='add'
        element={
          <ProtectedRoute
            component={<AddCompany />}
          />
        }
      />
    </Route>
    <Route
      path='/users'
    >
      <Route
        path=''
        element={
          <ProtectedRoute
            component={<ViewUsers />}
          />
        }
      />
      <Route
        path='add'
        element={
          <ProtectedRoute
            component={<AddUser />}
          />
        }
      />
      <Route
        path=':user_id/edit'
        element={
          <ProtectedRoute
            component={<EditUser />}
          />
        }
      />
      {/* <Route 
        path=':vehicle_id'
        element={
          <ProtectedRoute
            component={<EditVehicle/>}
          />
        } 
      /> */}
    </Route>
    <Route
      path='/customers'
    >
      <Route
        path=''
        element={
          <ProtectedRoute
            component={<ViewCustomers />}
          />
        }
      />
      <Route
        path='add'
        element={
          <ProtectedRoute
            component={<AddCustomer />}
          />
        }
      />
      <Route
        path=':customer_id/edit'
        element={
          <ProtectedRoute
            component={<EditCustomer />}
          />
        }
      />
    </Route>
    <Route
      path='/services'
    >
      <Route
        path=''
        element={
          <ProtectedRoute
            component={<ViewServices />}
          />
        }
      />
      {/* <Route
        path='add'
        element={
          <ProtectedRoute
            component={<AddCustomer />}
          />
        }
      />
      <Route
        path=':customer_id/edit'
        element={
          <ProtectedRoute
            component={<EditCustomer />}
          />
        }
      /> */}
    </Route>
    <Route
      path='/vehicles'
    >
      <Route
        path=''
        element={
          <ProtectedRoute
            component={<ViewVehicles />}
          />
        }
      />
      <Route
        path='add'
        element={
          <ProtectedRoute
            component={<AddVehicle />}
          />
        }
      />
      <Route
        path=':vehicle_id/edit'
        element={
          <ProtectedRoute
            component={<EditVehicle />}
          />
        }
      />
      <Route
        path='fleets'
      >
        <Route
          path=''
          element={
            <ProtectedRoute
              component={<ViewFleets />}
            />
          }
        />
        <Route
          path='add'
          element={
            <ProtectedRoute
              component={<AddFleet />}
            />
          }
        />
        <Route
          path=':fleet_id/edit'
          element={
            <ProtectedRoute
              component={<EditFleet />}
            />
          }
        />
      </Route>
      {/* <Route 
        path=':vehicle_id'
        element={
          <ProtectedRoute
            component={<EditVehicle/>}
          />
        } 
      /> */}
    </Route>
    <Route
      path='/settings'
    >
      <Route
        path=''
        element={
          <ProtectedRoute
            component={<ViewSettings />}
          />
        }
      />
      <Route
        path='profile'
        element={
          <ProtectedRoute
            component={<ViewSettings />}
          />
        }
      >
        <Route
          path='password'
          element={
            <ProtectedRoute
              component={<PasswordChange />}
            />
          }
        />
      </Route>
      <Route
        path='add'
        element={
          <ProtectedRoute
            component={<AddVehicle />}
          />
        }
      />
      {/* <Route 
        path=':vehicle_id'
        element={
          <ProtectedRoute
            component={<EditVehicle/>}
          />
        } 
      /> */}
    </Route>
    <Route
      path='store'
      element={
        <ProtectedRoute
          component={<ViewProducts />}
        />
      }
    ></Route>
    <Route
      path='company-register'
      element={
        <ProtectedRoute
          component={<CompanyRegister />}
        />
      }
    ></Route>
    <Route
      path='help-support'
      element={
        <ProtectedRoute
          component={<HelpSupport />}
        />
      }
    ></Route>
    <Route
      path='developer'
      element={
        <ProtectedRoute
          component={<DeveloperHub />}
        />
      }
    ></Route>
    <Route
      path='pickup-points'
    >
      <Route
        path=''
        element={
          <ProtectedRoute
            component={<PickupPoints />}
          />
        }
      />
      <Route
        path='add'
        element={
          <ProtectedRoute
            component={<AddPickupPoint />}
          />
        }
      />
      <Route
        path='edit'
        element={
          <ProtectedRoute
            component={<EditPickupPoint />}
          />
        }
      />
    </Route>
    <Route
      path='parcels'
    >
      <Route
        path=''
        element={
          <ProtectedRoute
            component={<ViewParcels />}
          />
        }
      />
      <Route
        path='add'
        element={
          <ProtectedRoute
            component={<AddParcelDelivery />}
          />
        }
      />
      <Route
        path='edit'
        element={
          <ProtectedRoute
            component={<EditParcelDelivery />}
          />
        }
      />
    </Route>
  </Routes>
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading="null" persistor={persistor}>
      <ChakraProvider>
        <React.StrictMode>
          <BrowserRouter>
            <AppContainer>
              {appRouting}
            </AppContainer>
          </BrowserRouter>
        </React.StrictMode>
      </ChakraProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
